import { getTodayParams } from '@/utils/tools/time';
import { getLocalStorage } from '@/utils/tools/utils';
import DownloadService from '@/views/content/api/download';
import NoticeService from '@/views/content/api/notice';

const userLogin = getLocalStorage('userLogin');
const businessTypes = getLocalStorage('BusinessTypes');

export default {
  namespaced: true,
  state: ({
    device: 'pc', // 设备
    userLogin: userLogin ? JSON.parse(userLogin || '{}') : '',
    currentLan: window.localStorage.getItem('lang') || 'en',
    showDownloadTask: false,
    showNoticeList: [],
    oldHostMap: {
      'sandbox-v3-merchant.pacypay.com': 'https://sandbox-portal.onerway.com',
      'v3-merchant.pacypay.com': 'https://portal.onerway.com',
    },
    stopOldHostDate: 1767196799000,
    childMerchantList: [], // 子商户列表，用于集团商户切换、筛选
    jumioUser: null,
    jumioStatus: JSON.parse(localStorage.getItem('jumioStatus')) || null,
    businessTypes: businessTypes ? JSON.parse(businessTypes || '{}') : '',
  }),
  mutations: {
    setUserLogin: (state, user) => {
      state.userLogin = user;
    },
    setLang: (state, lang) => {
      state.currentLan = lang;
    },
    setShowDownloadTask: (state, show) => {
      state.showDownloadTask = show;
    },
    setShowNotice: (state, list) => {
      state.showNoticeList = list;
    },
    setjumioUser: (state, data) => {
      state.jumioUser = data;
    },
    setjumioStatus: (state, data) => {
      state.jumioStatus = data;
    },
    setBusinessTypes: (state, data) => {
      state.businessTypes = data;
    },
  },
  actions: {
    setUserLogin: ({ commit }, user) => {
      commit('setUserLogin', user);
    },
    setjumioUser: ({ commit }, user) => {
      commit('setjumioUser', user);
    },
    setjumioStatus: ({ commit }, status) => {
      commit('setjumioStatus', status);
      localStorage.setItem('jumioStatus', JSON.stringify(status));
    },
    setLang: ({ commit }, lang) => {
      commit('setLang', lang);
    },
    setBusinessTypes: ({ commit }, data) => {
      commit('setBusinessTypes', data);
    },
    refreshDownloadTask: async ({ commit, state }) => {
      // 获取接口信息
      try {
        const params = {
          ...getTodayParams('beginDateTime', 'endDateTime'),
          size: -1,
          operatorId: state.userLogin.operatorId,
        };
        const res = await DownloadService.queryDownloadsExclude(params);
        const list = res.content || [];
        let show = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].fileStatus === 'GS' && ((+list[i].downloadFlag) === 2)) {
            show = true;
            break;
          }
        }
        commit('setShowDownloadTask', show);
      } catch (err) {
        console.log('queryDownloadsExclude: ', err);
      }
    },
    refreshNotice: async ({ commit }) => {
      try {
        const res = await NoticeService.queryUnReadList();
        const list = res || [];
        commit('setShowNotice', list.slice(0, 3)); // 最近三条
      } catch (err) {
        console.log('queryUnReadList: ', err);
      }
    },
  },
};
